module.exports = __webpack_public_path__ + "img/choose-up-Up Cultura-disabled.f51fe143.png";